import SEOHead from '@/components/SEOHead';
import Layout from '@/components/Layout';
import ArticlesConnexes from '@/components/ArticlesConnexes';
import NewsletterCapture from '@/components/NewsletterCapture';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Calendar, Clock, Music, TrendingUp, DollarSign, CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function MontreuxJazz2025Airbnb() {
  const navigate = useNavigate();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": "Montreux Jazz Festival 2025 : Maximiser Vos Revenus Airbnb (600-900 CHF/Nuit)",
    "description": "Stratégie complète Airbnb Montreux Jazz 2025 : dates 4-19 juillet, pricing 600-900 CHF/nuit, durée minimum, checklist préparation. +400% revenus.",
    "image": "https://images.unsplash.com/photo-1511735643442-503bb3bd348a?q=80&w=1200",
    "datePublished": "2025-01-12",
    "author": {"@type": "Organization", "name": "Homely Conciergerie"},
    "publisher": {"@type": "Organization", "name": "Homely Conciergerie"},
    "mainEntityOfPage": {"@type": "WebPage", "@id": "https://homely-conciergerie.ch/blog/montreux-jazz-festival-2025-airbnb"}
  };

  return (
    <Layout>
      <SEOHead title="Montreux Jazz Festival 2025 Airbnb : 600-900 CHF/Nuit | Guide Homely" description="Pricing Montreux Jazz 2025 : 600-900 CHF/nuit, durée min 4 nuits, stratégies réservations. +400% revenus 15 jours festival." keywords="montreux jazz 2025 airbnb, location montreux jazz festival, prix nuitée jazz montreux, revenus airbnb montreux juillet" canonical="https://homely-conciergerie.ch/blog/montreux-jazz-festival-2025-airbnb" image="https://images.unsplash.com/photo-1511735643442-503bb3bd348a?q=80&w=1200" type="article" jsonLd={jsonLd} />
      
      <div className="min-h-screen bg-[#F5F3EF]">
        <section className="relative py-32 px-6 bg-cover bg-center" style={{backgroundImage: `linear-gradient(rgba(43, 43, 43, 0.75), rgba(43, 43, 43, 0.85)), url('https://images.unsplash.com/photo-1511735643442-503bb3bd348a?q=80&w=2000')`}}>
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-4 text-white/80 mb-6">
              <span className="bg-[#8A9474] px-4 py-1 rounded-full text-sm font-semibold">Événement Saisonnier</span>
              <div className="flex items-center gap-2"><Calendar className="h-4 w-4" /><span className="text-sm">4-19 Juillet 2025</span></div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">Montreux Jazz Festival 2025 : Pricing Airbnb 600-900 CHF/Nuit</h1>
            <p className="text-xl text-gray-200">Le Montreux Jazz Festival 2025 (4-19 juillet) est LE pic de revenus annuel. Stratégie pricing, durée minimum et préparation pour générer <strong>8'000-12'000 CHF en 15 jours</strong>.</p>
          </div>
        </section>

        <article className="py-16 px-6">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
              <Card className="border-2 border-[#8A9474]"><CardContent className="p-6 text-center"><Music className="h-12 w-12 text-[#8A9474] mx-auto mb-4" /><div className="text-3xl font-bold text-[#2B2B2B] mb-2">4-19 Juillet</div><div className="text-sm text-[#4A4A4A]">Dates Festival 2025</div></CardContent></Card>
              <Card className="border-2 border-[#8A9474]"><CardContent className="p-6 text-center"><DollarSign className="h-12 w-12 text-[#8A9474] mx-auto mb-4" /><div className="text-3xl font-bold text-[#2B2B2B] mb-2">600-900 CHF</div><div className="text-sm text-[#4A4A4A]">Fourchette pricing/nuit</div></CardContent></Card>
              <Card className="border-2 border-[#8A9474]"><CardContent className="p-6 text-center"><TrendingUp className="h-12 w-12 text-[#8A9474] mx-auto mb-4" /><div className="text-3xl font-bold text-[#2B2B2B] mb-2">+400%</div><div className="text-sm text-[#4A4A4A]">vs prix normal juillet</div></CardContent></Card>
            </div>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#2B2B2B] mb-6 flex items-center gap-3"><CheckCircle2 className="h-8 w-8 text-[#8A9474]" />Stratégie Pricing Jazz 2025</h2>
              <div className="bg-white p-6 rounded-lg shadow-md space-y-6">
                <div className="border-l-4 border-[#8A9474] pl-4">
                  <h3 className="font-bold text-[#2B2B2B] mb-3">🎯 Grille Tarifaire Recommandée</h3>
                  <ul className="space-y-2 text-[#4A4A4A]">
                    <li>• <strong>Studio/1 pièce vue lac :</strong> 500-700 CHF/nuit (min 4 nuits)</li>
                    <li>• <strong>2-3 pièces proche centre :</strong> 700-900 CHF/nuit (min 5 nuits)</li>
                    <li>• <strong>4+ pièces vue lac premium :</strong> 1'000-1'500 CHF/nuit (min 7 nuits)</li>
                    <li>• <strong>Chalet/Villa groupes :</strong> 2'000-3'500 CHF/nuit (semaine complète)</li>
                  </ul>
                </div>

                <div className="border-l-4 border-[#8A9474] pl-4">
                  <h3 className="font-bold text-[#2B2B2B] mb-3">📅 Durée Minimum Critique</h3>
                  <p className="text-[#4A4A4A] mb-3">Imposez <strong>4-5 nuits minimum</strong> pendant Jazz. Rationale :</p>
                  <ul className="space-y-1 text-[#4A4A4A] text-sm">
                    <li>✓ Maximise CA (5 × 700 = 3'500 CHF vs 1 nuit isolée)</li>
                    <li>✓ Réduit turnover ménages (1 ménage vs 5)</li>
                    <li>✓ Filtre voyageurs sérieux (familles, groupes amis)</li>
                    <li>✓ Sécurise planning (pas de trous 1-2 nuits)</li>
                  </ul>
                </div>

                <div className="p-4 bg-[#E8EBE4] rounded-lg">
                  <p className="text-[#2B2B2B] font-semibold mb-2">💡 Astuce Calendrier</p>
                  <p className="text-sm text-[#4A4A4A]">Ouvrez réservations <strong>dès janvier 2025</strong>. 60% festivaliers réservent 4-6 mois avant. Prix +10% réservations &lt;30 jours (urgence).</p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#2B2B2B] mb-6">✅ Checklist Préparation Jazz</h2>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="space-y-3">
                  <div className="flex gap-3"><CheckCircle2 className="h-5 w-5 text-[#8A9474] flex-shrink-0 mt-0.5" /><p className="text-[#4A4A4A]"><strong>Mars-Avril :</strong> Ouvrir calendrier 4-19 juillet, fixer prix + durée min</p></div>
                  <div className="flex gap-3"><CheckCircle2 className="h-5 w-5 text-[#8A9474] flex-shrink-0 mt-0.5" /><p className="text-[#4A4A4A]"><strong>Mai :</strong> Photos refresh (fleurs été, balcon setup), update description "spécial Jazz"</p></div>
                  <div className="flex gap-3"><CheckCircle2 className="h-5 w-5 text-[#8A9474] flex-shrink-0 mt-0.5" /><p className="text-[#4A4A4A]"><strong>Juin :</strong> Check ménages disponibles (haute demande), stocks linges doublés</p></div>
                  <div className="flex gap-3"><CheckCircle2 className="h-5 w-5 text-[#8A9474] flex-shrink-0 mt-0.5" /><p className="text-[#4A4A4A]"><strong>1 semaine avant :</strong> Guide accès festival, restaurants, parking (valeur ajoutée guests)</p></div>
                  <div className="flex gap-3"><CheckCircle2 className="h-5 w-5 text-[#8A9474] flex-shrink-0 mt-0.5" /><p className="text-[#4A4A4A]"><strong>Pendant festival :</strong> Communication proactive (bruit OK ? besoins ?), avis 5★ garantis</p></div>
                </div>
              </div>
            </section>

            <section className="mt-16">
              <Card className="bg-gradient-to-br from-[#2B2B2B] to-[#4A4A4A] text-white">
                <CardContent className="p-12 text-center">
                  <h2 className="text-3xl font-bold mb-4">Gestion Jazz Festival Clé en Main</h2>
                  <p className="text-xl text-gray-200 mb-8">Homely optimise votre pricing, gère 100% turnover, maximise revenus. Zéro stress, résultats garantis.</p>
                  <Button onClick={() => navigate('/estimation')} size="lg" className="bg-[#8A9474] hover:bg-[#7A8464] text-white px-12 py-7 text-lg">Préparer Mon Bien Jazz 2025</Button>
                </CardContent>
              </Card>
            </section>

            <NewsletterCapture />

            <ArticlesConnexes currentSlug="montreux-jazz-festival-2025-airbnb" category="guide-ville" />

            <div className="mt-12 pt-8 border-t-2 border-gray-200">
              <Button onClick={() => navigate('/blog')} variant="outline" className="border-[#8A9474] text-[#8A9474] hover:bg-[#8A9474] hover:text-white">← Retour au Blog</Button>
            </div>
          </div>
        </article>
      </div>
    </Layout>
  );
}
